import axios from 'axios'
// import qs from 'qs'
import { getToken, routeTo, removeToken } from './index'

// import { dygcDomain } from '@utils/constants'

const token = getToken()
if (token) {
  axios.defaults.headers.token = token
}

axios.interceptors.request.use(
  (config) => {
    return {
      ...config,
      params: {
        ...config.params,
        token: getToken(),
      },
    }
  },
  (err) => {
    return Promise.reject(err)
  }
)

axios.interceptors.response.use(
  (config) => {
    return config
  },
  (err) => {
    if (
      err &&
      err.response &&
      err.response.status &&
      err.response.status === 401 &&
      err.response.data.msg !== '尚未加入应用'
    ) {
      console.log('err', err.response)
      console.log('token失效')
      removeToken()
      const { href } = window.location
      if (href.indexOf("refinement") === -1 && href.indexOf("statistics") === -1 && href.indexOf("role") === -1 && href.indexOf("standard") === -1) {
        // 跳转到登录页 方法
        routeTo({
          navType: 'push',
          url: '/login?key=xc',
          project: 'web',
        })
      } else if (window.LX && window.LX.platform.isAndroid) {
        window.location.reload()
      }

      // window.location.href = `${dygcDomain}/login?url=${window.location.href}`
    }
    return Promise.reject(err)
  }
)

export default axios
